import * as React from 'react';

import { PropertyInfoSubSectionViewModel, SectionType } from 'models';

import { UitkHeading } from 'uitk-react-text';

import { SectionBulletedList, SectionPlainList } from './section-list';

interface SectionsProps {
  section?: PropertyInfoSubSectionViewModel;
  dataStid: string;
}

export const Sections = ({ section, dataStid }: SectionsProps) => {
  if (!section || !dataStid) {
    return null;
  }

  return (
    <>
      {section.title &&
        section.formattedDescriptions &&
        section.formattedDescriptions.length > 0 && (
          <div className="all-y-padding-three">
            <UitkHeading level={2} size={500}>
              {section.title}
            </UitkHeading>
            {section.formattedDescriptions[0].sectionType === SectionType.BULLETED_LIST && (
              <ul key={dataStid} className="uitk-type-list-300">
                {section.formattedDescriptions.map((formattedDescription, index) => (
                  <SectionBulletedList
                    formattedDescription={formattedDescription}
                    index={index}
                    dataStid={dataStid}
                    textType={formattedDescription.textType}
                  />
                ))}
              </ul>
            )}
            {section.formattedDescriptions[0].sectionType === SectionType.PLAIN_LIST && (
              <>
                {section.formattedDescriptions.map((formattedDescription, index) => (
                  <SectionPlainList
                    formattedDescription={formattedDescription}
                    index={index}
                    dataStid={dataStid}
                    textType={formattedDescription.textType}
                  />
                ))}
              </>
            )}
          </div>
        )}
    </>
  );
};

Sections.displayName = 'Sections';
